import { Alpine } from "./alpine";
import { applyTheme } from "./theme";
import { initPasswordValidation, loadPasswordRules } from "./password_validation";

function initRegisterTheme(): void {
  // Progressive enhancement: check localStorage immediately
  const savedTheme = localStorage.getItem("theme");
  if (savedTheme && savedTheme !== "tokyo-night") {
    applyTheme(savedTheme);
  }
}

Alpine.data("register", () => ({
  init() {
    initRegisterTheme();
    // The requirements checklist + submit gating mirror the server's
    // ACTIVE complexity rules: without this the checklist stayed dead
    // markup and the Register button never enabled.
    loadPasswordRules().then(() => initPasswordValidation());
  },
}));
